import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import background from "./images/background.png";

const API = process.env.REACT_APP_API_URL || "";

export default function MigrationPage({
  token: tokenProp,
  quotes: quotesProp,
  sopas: sopasProp,
  onDone,
}) {
  const [migrating, setMigrating] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const token = tokenProp || location.state?.token;
  const quotes = quotesProp ?? location.state?.quotes ?? 0;
  const sopas = sopasProp ?? location.state?.sopas ?? 0;

  useEffect(() => {
    if (!token) navigate("/login", { replace: true });
  }, []);

  const handleMigrate = async (doMigrate) => {
    setError("");
    setMigrating(true);

    if (doMigrate && token) {
      try {
        const promises = [];
        if (quotes > 0) {
          promises.push(
            fetch(`${API}/api/scores`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ game: "completa_frase", score: quotes }),
            })
          );
        }
        if (sopas > 0) {
          promises.push(
            fetch(`${API}/api/scores`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ game: "sopa_letras", score: sopas }),
            })
          );
        }
        const results = await Promise.all(promises);
        if (results.some((r) => !r.ok)) throw new Error("Score migration failed");

        await fetch(`${API}/api/auth/record`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            record_completa_frase: quotes,
            record_sopas: sopas,
          }),
        });
      } catch (err) {
        console.error("Error migrando:", err);
        setError("Hubo un error al pasar tus puntos 😢 Intenta de nuevo.");
        setMigrating(false);
        return;
      }
    }

    try {
      await fetch(`${API}/api/auth/mark-migrated`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err) {
      console.error("Error marcando migración:", err);
    }

    localStorage.removeItem("karime_game_high_score_v1");
    localStorage.removeItem("kk_sopas_completadas_ever");
    setMigrating(false);

    if (onDone) onDone();
    navigate("/perfil");
  };

  return (
    <div
      className="flex flex-col font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        minHeight: "calc(100vh - 120px)",
      }}
    >
      <div className="px-5 pt-8 pb-10 flex flex-col gap-6">
        {/* Norris con glow */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "8px",
          }}
        >
          <div
            style={{
              width: "110px",
              height: "110px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow:
                "0 0 40px rgba(123,220,251,0.35), 0 0 80px rgba(196,181,253,0.2)",
              background: "rgba(255,255,255,0.6)",
            }}
          >
            <img
              src="https://res.cloudinary.com/dbvqeiqxb/image/upload/v1778455107/32e298c1550e90f36f16458ba73881e0b0235effa618a31a315d469c272dbcbf_pohuhc.png"
              alt="Norris"
              style={{ width: "96px", height: "96px", objectFit: "contain" }}
            />
          </div>
        </div>

        {/* Header */}
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <p
            style={{
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              color: "#b06ab3",
              textTransform: "uppercase",
            }}
          >
            ¡Bienvenida bb!
          </p>
          <h1
            style={{
              fontSize: "22px",
              fontWeight: 800,
              color: "#2d1f3d",
              lineHeight: 1.25,
            }}
          >
            ✨ Tu progreso está a salvo
          </h1>
          <p
            style={{
              fontSize: "13px",
              color: "#9b7eaa",
              lineHeight: 1.65,
              maxWidth: "300px",
              margin: "0 auto",
            }}
          >
            Tus juegos y puntos estaban guardados en este dispositivo 💖
            ¿Quieres pasarlos a tu cuenta para no perderlos?
          </p>
        </div>

        {/* Cards */}
        <div style={{ display: "flex", gap: "10px" }}>
          {quotes > 0 && (
            <div
              style={{
                flex: 1,
                background: "rgba(219,244,255,0.7)",
                borderRadius: "20px",
                border: "1.5px solid #7BDCFB",
                padding: "16px 12px",
                textAlign: "center",
                boxShadow: "0 2px 12px rgba(123,220,251,0.15)",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <span style={{ fontSize: "28px" }}>✨</span>
              <p
                style={{
                  fontSize: "24px",
                  fontWeight: 800,
                  color: "#b06ab3",
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                {quotes}
              </p>
              <p
                style={{
                  fontSize: "11px",
                  color: "#9b7eaa",
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                frases completadas
              </p>
            </div>
          )}
          {sopas > 0 && (
            <div
              style={{
                flex: 1,
                background: "rgba(237,233,254,0.7)",
                borderRadius: "20px",
                border: "1.5px solid #c4b5fd",
                padding: "16px 12px",
                textAlign: "center",
                boxShadow: "0 2px 12px rgba(196,181,253,0.15)",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <span style={{ fontSize: "28px" }}>🧩</span>
              <p
                style={{
                  fontSize: "24px",
                  fontWeight: 800,
                  color: "#b06ab3",
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                {sopas}
              </p>
              <p
                style={{
                  fontSize: "11px",
                  color: "#9b7eaa",
                  fontWeight: 600,
                  lineHeight: 1.4,
                }}
              >
                sopas resueltas
              </p>
            </div>
          )}
        </div>

        {error && (
          <p style={{ fontSize: "12px", color: "#f87171", textAlign: "center", margin: 0 }}>
            {error}
          </p>
        )}

        {/* Botones */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <button
            onClick={() => handleMigrate(true)}
            disabled={migrating}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "15px",
              fontSize: "15px",
              fontWeight: 700,
              color: "white",
              fontFamily: "Quicksand, sans-serif",
              cursor: migrating ? "not-allowed" : "pointer",
              background: migrating
                ? "#b0e8fb"
                : "linear-gradient(135deg, #7BDCFB, #6ec6f5)",
              boxShadow:
                "0 8px 24px rgba(104,205,255,0.35), 0 2px 8px rgba(104,205,255,0.2)",
            }}
          >
            {migrating
              ? "Pasando tus puntos..."
              : "⭐ Sí, quiero pasar mis puntos"}
          </button>
          <button
            onClick={() => handleMigrate(false)}
            disabled={migrating}
            style={{
              background: "rgba(255,255,255,0.85)",
              border: "1.5px solid #e0d0f0",
              borderRadius: "999px",
              padding: "13px",
              fontSize: "13px",
              fontWeight: 700,
              color: "#b0a0be",
              fontFamily: "Quicksand, sans-serif",
              cursor: "pointer",
            }}
          >
            No, quiero empezar desde cero
          </button>
        </div>
      </div>
    </div>
  );
}
